import script from "./info_event.vue?vue&type=script&setup=true&lang=js"
export * from "./info_event.vue?vue&type=script&setup=true&lang=js"

import "./info_event.vue?vue&type=style&index=0&id=371e1806&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-371e1806"]])

export default __exports__